"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const RetentionTabsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionTabsJSONModel");
const RetentionTypeJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionTypeJSONModel");
class RetentionJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.retentionTypeJSONModel = new RetentionTypeJSONModel_1.RetentionTypeJSONModel();
        this.chartSettingsJSONModel = new RetentionChartSettingsJSONModel_1.RetentionChartSettingsJSONModel();
        this.tabsJSONModel = new RetentionTabsJSONModel_1.RetentionTabsJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.retentionTypeJSONModel.reset();
            this.chartSettingsJSONModel.reset();
            this.tabsJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
                // if (!!process.env.IS_TEST_SERVER) {
                this.retentionTypeJSONModel.overwriteFromSerializedState(serializedState.retentionType);
                this.tabsJSONModel.overwriteFromSerializedState(serializedState.tabs);
                // }
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
                retentionType: this.retentionTypeJSONModel.serialize(),
                tabs: this.tabsJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.getTabsJSONModel = () => this.tabsJSONModel;
        this.getRetentionTypeJSONModel = () => this.retentionTypeJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.RetentionJSONModel = RetentionJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
RetentionJSONModel.isModelEmpty = (serializedState) => {
    var _a, _b;
    const jsonModel = new RetentionJSONModel(serializedState);
    const tabsJSONModel = jsonModel.getTabsJSONModel();
    const activeTabUniqueId = tabsJSONModel.getActiveUniqueId();
    const numberOfCohortVariants = (_a = tabsJSONModel.getCohortJSONModel(activeTabUniqueId)) === null || _a === void 0 ? void 0 : _a.getNumberOfQueryEventVariants();
    const numberOfReturnVariants = (_b = tabsJSONModel.getReturnJSONModel(activeTabUniqueId)) === null || _b === void 0 ? void 0 : _b.getNumberOfQueryEventVariants();
    return (numberOfCohortVariants || 0) === 0 || (numberOfReturnVariants || 0) === 0;
};
RetentionJSONModel.makeModelStateClean = (serializedState) => {
    var _a, _b;
    const jsonModel = new RetentionJSONModel(serializedState);
    const tabsJSONModel = jsonModel.getTabsJSONModel();
    const activeTabUniqueId = tabsJSONModel.getActiveUniqueId();
    // console.log("makeModelStateClean before", tabsJSONModel.serialize());
    // console.log(`makeModelStateClean tabsJSONModel.getCohortJSONModel(${activeTabUniqueId})`, tabsJSONModel.getCohortJSONModel(activeTabUniqueId));
    // console.log(`makeModelStateClean tabsJSONModel.getReturnJSONModel(${activeTabUniqueId})`, tabsJSONModel.getReturnJSONModel(activeTabUniqueId));
    (_a = tabsJSONModel.getCohortJSONModel(activeTabUniqueId)) === null || _a === void 0 ? void 0 : _a.removeNotFilledQueryEventVariants();
    (_b = tabsJSONModel.getReturnJSONModel(activeTabUniqueId)) === null || _b === void 0 ? void 0 : _b.removeNotFilledQueryEventVariants();
    // console.log("makeModelStateClean after", tabsJSONModel.serialize());
    return jsonModel.serialize();
};
